import { admin, forecaster, user } from "./axios";

export enum UserGroup {
  Admin = "admin",
  Forecaster = "forecaster",
  User = "user",
}

export const getAxiosInstance = (group: UserGroup) => {
  switch (group) {
    case UserGroup.Admin:
      return admin;
    case UserGroup.Forecaster:
      return forecaster;
    default:
      throw new Error("Invalid user group");
  }
};
